function initializeAudioPLayer(){

	if ( $('.audio-player-wrapper').length > 0 ){

		$('.audio-player-wrapper').each(function(){

			var id = $(this).attr('id');

		 	var audio_player = $('#'+id+' .audio-player');
		 	var play_button = $('#'+id+' .btn-box');
		 	var progress_bar = $('#'+id+' .progressbar');
		 	var time = $('#'+id+' .current-time');
		 	var total_time = $('#'+id+' .total-time');
		 	var mute_button = $('#'+id+' .mute');
		 	var volume_bar = $('#'+id+' .volume');
		 	var duration = 0;
		 	var volume = 0.75;

		 	var player = document.getElementById('player-'+id);

		 	player.onloadedmetadata = function() {
		 	    duration = player.duration;
		 	    total_time.text(getTime(duration));
		 	    progress_bar.progressbar("option", { 'max' : duration });
		 	};

		 	player.load();
		 	// player.volume = 0.75;
		 	player.volume = 1;
		 	player.addEventListener("timeupdate", function() {
		 	    progress_bar.progressbar('value', player.currentTime);
		 	    time.text(getTime(player.currentTime));
		 	}, false);

		 	function getTime(t) {
		 	    var m=~~(t/60), s=~~(t % 60);
		 	    return (m<10?"0"+m:m)+':'+(s<10?"0"+s:s);
		 	}

		 	function getProgressBarClickInfo(progress_bar, e) {
		 	    var offset = progress_bar.offset();
		 	    var x = e.pageX - offset.left; // or e.offsetX (less support, though)
		 	    var y = e.pageY - offset.top;  // or e.offsetY
		 	    var max = progress_bar.progressbar("option", "max");
		 	    var value = x * max / progress_bar.width();

		 	    return { x: x, y: y, max: max, value: value };
		 	}

		 	volume_bar.progressbar({
		 	    value : player.volume*100,
		 	});

		 	volume_bar.click(function(e) {
		 	    var info = getProgressBarClickInfo($(this), e);
		 	    volume_bar.progressbar('value', info.value);
		 	    player.volume = info.value / info.max;
		 	});

		 	progress_bar.progressbar({
		 	    value : player.currentTime,
		 	});

		 	progress_bar.click(function(e) {
		 	    var info = getProgressBarClickInfo($(this), e);
		 	    player.currentTime = player.duration / info.max * info.value;
		 	});

		 	play_button.click(function() {

		 		//stop all other payers
		 		var curId = $(this).closest('.audio-player-wrapper').attr('id');
		 		$( '.audio-player-wrapper' ).each(function(){
		 			if( $(this).attr('id') !== curId ){
		 				if( $(this).find('.btn-box').children('.fa').hasClass('fa-pause') ){//if is playing stop it
		 					$(this).find('.btn-box').trigger('click');
		 				}
		 			}
		 		});

		 	    player[player.paused ? 'play' : 'pause']();
		 	    $(this).children('.fa').toggleClass("fa-play", player.paused);
		 	    $(this).children('.fa').toggleClass("fa-pause", !player.paused);
		 	});

		 	mute_button.click(function() {
		 	    if (player.volume == 0) {
		 	        player.volume = volume;
		 	    } else {
		 	        volume = player.volume;
		 	        player.volume = 0;
		 	    }

		 	    volume_bar.progressbar('value', player.volume * 100);

		 	    $(this).toggleClass("fa-volume-up", player.volume != 0);
		 	    $(this).toggleClass("fa-volume-off", player.volume == 0);
		 	});



		});

	}
	

}